import React from 'react';
import type { Highlight } from '@hotjar/webapp/domains/highlights/model';
import { HeatmapPopoverContainer } from './HeatmapPopoverContainer';
import { RecordingPopoverContainer } from './RecordingPopoverContainer';

export const POPOVER_WIDTH = 364;

export const POPOVER_MAX_HEIGHT = 500;

interface HighlightsContainerProps {
  highlight: Highlight;
  siteId: string;
  currentUser: { id: string };
  onClose: () => void;
  children: React.ReactNode;
  onShare: (from: number) => void;
  className?: string;
}

export const HighlightPopoverContainer = ({
  highlight,
  siteId,
  currentUser,
  onClose,
  children,
  onShare,
  className,
}: HighlightsContainerProps): JSX.Element | null => {
  if (typeof highlight === 'undefined' || siteId === null || highlight === null) {
    return null;
  }

  if (highlight.type === 'recording') {
    return (
      <RecordingPopoverContainer
        highlight={highlight}
        siteId={siteId}
        currentUser={currentUser}
        onClose={onClose}
        onShare={onShare}
        className={className}
      >
        {children}
      </RecordingPopoverContainer>
    );
  }

  if (highlight.type === 'heatmap') {
    return (
      <HeatmapPopoverContainer
        highlight={highlight}
        siteId={siteId}
        currentUser={currentUser}
        onClose={onClose}
        className={className}
      >
        {children}
      </HeatmapPopoverContainer>
    );
  }

  return null;
};
